//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV>
  <Row>
    <Col :span="toggleTable == true ? 12 : 0" style="padding-right:20px;" :class="(toggleTable == false) ? 'hidden' : ''">
      <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" :disabled="(editingDataRow != null) && (editingDataRow.val.id == null)" @click="newEditingDataRowOnClick">Создать новую запись</Button>
    </Col>
    <Col :span="toggleTable == true ? 12 : 24" style="padding-right:20px;">
      <div style="float:left">
        <Button type="text" class="top-panel-toggle-mainmenu-button" @click="toggleCollapseTableOnClick">
          <Icon :type="toggleTable == false ? 'chevron-right' : 'chevron-left'"></Icon>
        </Button>
      </div>
    </Col>
  </Row>


  <Row>
    <Col :span="toggleTable == true ? 12 : 0" style="height:100%; padding-right:20px;" :class="(toggleTable == false) ? 'hidden' : ''">

      <div v-if="(options.viewType == null) || (options.viewType == 'standardTable')" class='entity-manager' style="width:100%">
        <table style="width:100%; padding-right:16px; padding-top:0px; border-spacing:0px;">
          <tr style="width:100%;">
            <th v-for="(column, keyColumn) in options.tableColumns" :key="keyColumn" :width="column.width"
             style="padding:5px 10px 5px 5px;font-weight:normal;border-bottom: 1px solid #ccc;" align="left">
              {{column.title}}
            </th>
            <th v-if="options.disableDelete != true" width="86px" align="left" style="font-weight:normal;border-bottom: 1px solid #ccc;">Действия</th>
            <th v-else width="17px" align="left" style="font-weight:normal;border-bottom: 1px solid #ccc;">&nbsp;</th>
          </tr>
        </table>
        <div class="entity-manager-scroll">
          <table style="width:100%;padding-top:0px;border-spacing:0px;">
            <tr v-for="(itemData, keyData) in data" :key="keyData" @click="dataRowOnSelect(itemData)" style="width:100%;height:32px;"
             :style="{background: (isRowSelected(itemData) ? 'rgb(108,118,175)' : ''), color: (isRowSelected(itemData) ? 'rgb(240,240,240)' : '')}">
              <td v-for="(column, keyColumn) in options.tableColumns" :key="keyColumn" :width="column.width"
               style="font-size:14px;padding:5px 10px 0px 5px;" align="left" >
               <slot name="dataItemFieldTableView" :dataRow="itemData" :column="column"> Нет данных </slot>
              </td>
              <td v-if="options.disableDelete != true" width="70px" style="font-size:14px;padding:5px 10px 0px 5px;" align="left">
                <Button type="text" style="border-radius:0px; margin:0px; padding: 0px; color:rgb(149,158,165); font-size:17px;" @click="deleteEditingDataRowOnClick(itemData)">
                  <Icon type="trash-b"></Icon>
                </Button>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div v-else-if="options.viewType == 'draggTreeview'" class='entity-manager' id='entity-manager' style="width:100%">
        <dragg-treeview :data.sync="draggableData" :options="draggTreeviewOptions" :selectedDataItem="selectedDataRow" @change="draggableDataOnChange" @select="dataRowOnSelect" @delete="deleteEditingDataRowOnClick">
          <template slot="propertyBox" scope="viewProps">
            <slot name="dataItemFieldTableView" :dataRow="viewProps.dataRow"> Нет данных </slot>
          </template>
        </dragg-treeview>
      </div>

    </Col>


    <Col :span="toggleTable == true ? 12 : 24" style="padding: 10px 20px 30px 20px; border-left:0px solid #ccc;">

      <div v-if="editingDataRow != null">

        <div v-for="(item, key) in options.editorFields" :key="key" style="width:100%">
          <div v-if="item != '___'" style="width:100px; padding-bottom: 10px; display:inline-block; float:left;">
            <span v-html="options.editorFields[key]+':'"></span>
          </div>
          <div style="padding-bottom: 10px; display:inline-block; clear:left;" :style="item != '___' ? 'width:calc(100% - 100px)' : 'width:100%'">
            <slot name="dataItemFieldEditView" :editingDataRow="editingDataRow" :fieldItem="item" :fieldKey="key"> Нет данных </slot>
          </div>
        </div>

        <div style="padding: 30px 0px 0px 0px;">
          <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveEditingDataRowOnClick">Сохранить</Button>
          <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelEditingDataRowOnClick">Отменить</Button>
        </div>

      </div>

      <div v-else>
        * Выберите запись для просмотра или редактирования
      </div>

    </Col>
  </Row>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
// import Vue from 'Vue'
import { mapGetters, mapMutations } from 'vuex'

import draggable from 'vuedraggable'

import async from 'async'

// import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import mainCommonDataLoader from '@/components/mainCommonDataLoader'

import treeviewData from '@/technical/components/Treeview/treeviewData'
import DraggTreeview from '@/technical/components/Treeview/DraggTreeview'

export default {
  props: ['options', 'data'],
  components: { draggable, DraggTreeview },
  data () {
    return {
      toggleTable: true,

      selectedDataRow: null,
      editingDataRow: null,

      draggableData: null
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser'
    ]),
    draggTreeviewOptions () {
      return {
        isRoot: true,
        draggableComponent: {
          animation: 0,
          group: 'EntityManagerDataItems',
          scroll: true
        }
      }
    }
  },
  watch: {
    data (newData) {
      console.log('entityManager watcher.data')
      this.draggableData = treeviewData(newData, {ui: {toggle: true}})

      function draggableDataToggleEmptyLists (list) { // это надо чтобы при добавлении элемента в пустой список детей этот список был потом открыт
        if (list == null) return
        for (var i = 0; i < list.length; i++) {
          if (list[i].children.length === 0) list[i].ui.toggle = true
          else draggableDataToggleEmptyLists(list[i].children)
        }
      }
      draggableDataToggleEmptyLists(this.draggableData)
    }
  },
  methods: {
    draggableDataRecalcChainIndxesAndPathToParent (/* parentObj, */list, pathToParent) {
      // if (pathToParent === '.') console.log('recalcDraggableDataChainIndxesAndPathToParent')
      if (list == null) return
      for (var i = 0; i < list.length; i++) {
        // if (list[i].val.id === 72) {
        //   console.log('+++++++++++++++ into recalc obj72 is found')
        //   console.log(list[i].val)
        // }
        list[i].val.chainIndx = i + 1
        // list[i].val.parent = parentObj
        list[i].val.pathToParent = pathToParent
        this.draggableDataRecalcChainIndxesAndPathToParent(/* list[i], */list[i].children, pathToParent + list[i].val.id + '.')
        // if (list[i].val.id === 72) {
        //   console.log(list[i].val)
        //   console.log(list)
        //   console.log('+++++++++++++++')
        // }
      }
    },
    draggableDataOnChange () {
      console.log('draggableDataOnChange !!!!!!!!!!! MAIN !!!!!!!!!!!!!!!!')
      this.selectedDataRow = null
      this.editingDataRow = null
      this.draggableDataRecalcChainIndxesAndPathToParent(/* null, */this.draggableData, '.')
      this.saveAllDataAfterDraggingItem() // !!!!!!!!!!!!!!!!!!! НЕ РАСКОМЕНЧИВАТЬ ПОКА
    },
    saveAllDataAfterDraggingItem () {
      console.log('saveAllDataAfterDraggingItem')
      var thisRef = this
      // console.log(thisRef.data)
      // console.log(thisRef.draggableData)
      thisRef.$message.info('Данные начали сохраняться')
      async.each(thisRef.data, function (dataItem, callback) {
        dataItem.save()
        .then(function (response) {
          dataItem.val = response.data
          callback()
        })
        .catch((error) => callback(error))
      }, function (error) {
        if (error !== null) serverErrorHandling(error, thisRef)
        else {
          thisRef.$message.success('Данные сохранены на сервер')
        }
      })
    },
    toggleCollapseTableOnClick () {
      if (this.toggleTable === false) {
        this.toggleTable = true
      } else {
        this.toggleTable = false
      }
    },
    dataRowOnSelect (value) {
      // console.log('dataRowOnSelect@@@@')
      // console.log(value.val.id)
      this.selectedDataRow = value
      this.editingDataRow = Object.assign({}, value)
      // this.editingDataRow = {}
      this.editingDataRow.val = Object.assign({}, value.val)
    },
    isRowSelected (row) {
      if (this.selectedDataRow == null) return false
      if (row.val.id === this.selectedDataRow.val.id) return true
      else return false
    },
    newEditingDataRowOnClick () {
      console.log('newEditingDataRowOnClick')
      this.selectedDataRow = null
      let newEntity = Object.assign({}, this.options.newEmptyEntity(this))
      // console.log(newEntity)
      // this.data.push(newEntity)
      // this.dataRowOnSelect(newEntity)
      this.editingDataRow = Object.assign({}, newEntity)
      this.editingDataRow.val = Object.assign({}, newEntity.val)
    },
    cancelEditingDataRowOnClick () {
      console.log('cancelEditingDataRowOnClick')
      /* вариант поведения если Отмена - это стереть набранные данные и вернутся к изначальным значениям не закрывая форму редактируемой записи
      if (this.selectedDataRow == null) { // это случай если редактируется вновь созданная запись
        return this.newEditingDataRowOnClick()
      }
      this.editingDataRow = Object.assign({}, this.selectedDataRow)
      this.editingDataRow.val = Object.assign({}, this.selectedDataRow.val)
      */
      // var selectedDataRow = this.selectedDataRow
      this.selectedDataRow = null
      this.editingDataRow = null
      // if (selectedDataRow != null) this.$set(selectedDataRow, 'val', Object.assign({}, selectedDataRow.val))
    },
    saveEditingDataRowOnClick () {
      console.log('saveEditingDataRowOnClick')
      var thisRef = this
      thisRef.editingDataRow.save()
      .then(function (response) {
        thisRef.editingDataRow.val = response.data
        if (thisRef.selectedDataRow == null) { // это случай если редактируется вновь созданная запись
          let newSelectedDataRow = Object.assign({}, thisRef.options.newEmptyEntity(thisRef))
          newSelectedDataRow.val = Object.assign({}, thisRef.editingDataRow.val)
          thisRef.data.push(newSelectedDataRow)
          thisRef.selectedDataRow = newSelectedDataRow
        } else {
          thisRef.selectedDataRow.val = Object.assign({}, thisRef.editingDataRow.val)
          // далее надо удалить этот элемент из данных и снова его добаить для того чтобы thisRef.data изменилась
          // и тогда сработает watcher data выше и вся draggableData пересоберется,
          // а нам это надо в случае если при редактировании pathToParent был изменен и наш элемент сядет в новый нужный children
          if (thisRef.options.viewType === 'draggableTree') {
            for (var i = 0; i < thisRef.data.length; i++) {
              if (thisRef.data[i].val.id === thisRef.editingDataRow.val.id) {
                thisRef.data.splice(i, 1)
                thisRef.data.push(thisRef.editingDataRow)
                break
              }
            }
          }
        }

        // если это viewType = draggableTree то надо после добавления новой записи пересчитать chainIndx и pathToParent и сохранить на сервер
        // nextTick нужен чтобы thisRef.data.push(newSelectedDataRow) выше сработал (прошел через движок vue) и тогда сработает watcher data и добавится новый элемент в draggableData
        if (thisRef.options.viewType === 'draggableTree') {
          thisRef.editingDataRow = null

          // thisRef.$nextTick(() => {
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // thisRef.draggableDataOnChange({})
          // })
        }

        thisRef.commonDataIsLoadedSet(false)
        mainCommonDataLoader(thisRef.options.commonDataReloadOptions, function (error) {
          if (error !== null) return serverErrorHandling(error, thisRef)
          else {
            thisRef.commonDataIsLoadedSet(true)
            thisRef.$message.success('Запись сохранена на сервер')
          }
        })
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    deleteEditingDataRowOnClick (value) {
      console.log('deleteEditingDataRowOnClick')
      var thisRef = this
      if ((value.children != null) && (value.children.length > 0)) {
        thisRef.$message.error('Невозможно удалить запись: у записи есть вложенные данные, сначала удалите их')
        return
      }

      value.delete()
      .then(function (response) {
        var index = thisRef.data.indexOf(value)
        thisRef.data.splice(index, 1)
        if ((thisRef.editingDataRow != null) && (value.val.id === thisRef.editingDataRow.val.id)) {
          thisRef.editingDataRow = null
          thisRef.selectedDataRow = null
        }
        thisRef.$message.success('Запись удалена с сервера')
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    ...mapMutations([
      'commonDataIsLoadedSet'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
#entity-manager .dtv-property-box-as-root {
  color: #778087;
  background: #e8e8e8;
}
</style>

/////////////////////////////////////////////////////

<style scoped>
.entity-manager{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.entity-manager-scroll {
  overflow-y: scroll;   /* надо чтобы работал scroll для mainMenu */
  height: calc(100vh - 190px);
  /* width: 257px; /* минимум на 17 пикселей больше чем mainmenu-panel.width, ща сделал на 50 больше */
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// EntityManager.vue?3afd4c43